import React from "react";

import { useStockPage } from "./StockPageContext";
import type { StockPageContextValue } from "./types";

/**
 * Class-component HOC: injects the full stock-page context as props.
 */
export function withStockPage<P extends object>(
  WrappedComponent: React.ComponentType<P & StockPageContextValue>
): React.ComponentType<Omit<P, keyof StockPageContextValue>> {
  function WithStockPage(props: Omit<P, keyof StockPageContextValue>) {
    const stockPage = useStockPage();
    return <WrappedComponent {...(props as P)} {...stockPage} />;
  }

  WithStockPage.displayName = `withStockPage(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return WithStockPage;
}
